import avatar1 from "@/assets/illustrations/avatars/avatar-1.svg";
import { safeGetItem, safeSetItem, safeRemoveItem } from "@/utils/safeStorage";
import avatar2 from "@/assets/illustrations/avatars/avatar-2.svg";
import avatar3 from "@/assets/illustrations/avatars/avatar-3.svg";
import avatar4 from "@/assets/illustrations/avatars/avatar-4.svg";
import avatar5 from "@/assets/illustrations/avatars/avatar-5.svg";

const PROFILE_AVATAR_STORAGE_KEY = "profile_avatar_url";

export const AVATAR_OPTIONS = [
	{ id: "avatar-1", src: avatar1 },
	{ id: "avatar-2", src: avatar2 },
	{ id: "avatar-3", src: avatar3 },
	{ id: "avatar-4", src: avatar4 },
	{ id: "avatar-5", src: avatar5 },
] as const;

export function resolveProfileAvatarUrl(
	profileAvatarUrl?: string | null,
	fallbackAvatarUrl?: string | null,
): string | undefined {
	if (profileAvatarUrl) {
		const option = AVATAR_OPTIONS.find((item) => item.id === profileAvatarUrl);
		return option?.src || profileAvatarUrl;
	}

	return fallbackAvatarUrl || undefined;
}

export function getStoredProfileAvatarUrl(): string | null {
	if (typeof window === "undefined") return null;
	const value = safeGetItem(PROFILE_AVATAR_STORAGE_KEY);
	return value && value.length > 0 ? value : null;
}

export function setStoredProfileAvatarUrl(avatarUrl: string | null): void {
	if (typeof window === "undefined") return;
	if (avatarUrl && avatarUrl.length > 0) {
		safeSetItem(PROFILE_AVATAR_STORAGE_KEY, avatarUrl);
		return;
	}
	safeRemoveItem(PROFILE_AVATAR_STORAGE_KEY);
}
